"use strict";
/**
 * @description 粘贴图片
 * @author wangfupeng
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var paste_event_1 = require("../../../text/paste/paste-event");
var upload_img_1 = __importDefault(require("../upload-img"));
/**
 * 剪切板是否有 text 或者 html ？
 * @param editor 编辑器对象
 * @param e 粘贴事件参数
 */
function _haveTextOrHtml(editor, e) {
    var config = editor.config;
    var pasteFilterStyle = config.pasteFilterStyle;
    var pasteIgnoreImg = config.pasteIgnoreImg;
    var pasteHtml = paste_event_1.getPasteHtml(e, pasteFilterStyle, pasteIgnoreImg);
    var pasteText = paste_event_1.getPasteText(e);
    if (pasteHtml)
        return true;
    if (pasteText)
        return true;
    return false; // text html 都没有，则返回 false
}
/**
 * 粘贴图片事件方法
 * @param e 事件参数
 */
function pasteImgHandler(e, editor) {
    if (_haveTextOrHtml(editor, e)) {
        // 粘贴过来的有 text 或者 html ，则不执行粘贴图片逻辑
        return;
    }
    // 获取粘贴的图片列表
    var pastedFiles = paste_event_1.getPasteImgs(e);
    if (!pastedFiles.length) {
        return;
    }
    // code 中忽略（暂不管它）
    // 执行上传
    var uploadImg = new upload_img_1.default(editor);
    uploadImg.uploadImg(pastedFiles);
}
/**
 * 粘贴图片
 * @param editor 编辑器对象
 * @param pasteEvents 粘贴事件列表
 */
function bindPasteImg(editor) {
    // 绑定 paste 事件
    editor.txt.eventHooks.pasteEvents.push(function (e) {
        pasteImgHandler(e, editor);
    });
}
exports.default = bindPasteImg;
